const NotFound = () => {
  return (
    <div className="row">
				<div className="col-md-3 col-sm-12 text-center">
					<img src="https://www.bca.co.id/-/media/Feature/Content/Benefit/guideline-img/atoms-visualicon-96-px-no-result.svg?v=1" alt="no result" />
				</div>
				<div className="col-md-8 col-sm-12 py-4">
					<p className="a-text a-text-subtitle mt-32 pl-16 mb-0 tittle">Hmm, Kata kunci yang kamu cari tidak ditemukan...</p>
          <div className="summary-text mt-16 mb-24 a-text a-text-small a-text-brownish-grey pl-16">Ulangi pencarian dengan kata kunci lainnya.</div>
				</div>
    </div>
  )
}

export default NotFound